var $52e8b1b00094e5a3$exports = {};
$52e8b1b00094e5a3$exports = {
    "close": `\u{95DC}\u{9589}`,
    "notifications": `\u{901A}\u{77E5}`
};


export {$52e8b1b00094e5a3$exports as default};
//# sourceMappingURL=zh-TW.module.js.map
